import client from './client';

export default {
  create(email, password, cb) {
    const req = client.request('post', '/sessions');
    req
      .send({ email, password })
      .end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/session.js